// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"az_iRb","Title":"az_jRb","DesktopCta":"az_kRb"};